import { render } from "./PannelloFunzionalita.vue?vue&type=template&id=62715e4b&scoped=true"
import script from "./PannelloFunzionalita.vue?vue&type=script&lang=js"
export * from "./PannelloFunzionalita.vue?vue&type=script&lang=js"

import "./PannelloFunzionalita.vue?vue&type=style&index=0&id=62715e4b&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62715e4b"]])

export default __exports__